import React from 'react';
import classnames from 'classnames';
import { useProduct } from '@ignitesales/neuro-application/src/neuro-guide';

const CartProduct = ({ product, actionType, selectedProducts, handleProductToggle }) => {
  const classes = classnames('productContainer__products--single', {'selectable': actionType === 1 });

  const {
    name,
    onSelectClick,
  } = useProduct(product);
  
  return actionType === 1 ? 
    <div  className={ classes } actionType={actionType} onClick={() => handleProductToggle(product)}>
       <h4>
          <button onClick={ onSelectClick } className={'removeFromCart'}><i className={'fa fa-times'} /></button>
          { name }
        </h4>
      <span className={classnames('checkmark', {'checked': selectedProducts.includes(product)})}></span>
    </div> : 
    <div className={ classes } actionType={actionType}>
        <h4>
          <button onClick={ onSelectClick } className={'removeFromCart'}><i className={'fa fa-times'} /></button>
          { name }
        </h4>
    </div>;
};

export default CartProduct;
